<script setup lang="ts">
import InfluencerBadgeIcon from '~/components/influencer/badgeIcon.vue'
import InfluencerGrooverNote from '~/components/influencer/profile/about/info/GrooverNote.vue'
import IconDescriptionElement from '~/components/ui/Sections/IconDescriptionElement.vue'
import OrangeTitleWithSpacedContent from '~/components/ui/Sections/OrangeTitleWithSpacedContent.vue'
import VText from '~/components/ui/VText.vue'

import { useGetCuratorBadgeName } from '~/composables/useGetCuratorBadgeName'

import type { Influencer } from '~/types/influencer'

type Props = {
  influencer: Influencer
}

const props = defineProps<Props>()

const getCuratorBadgeName = useGetCuratorBadgeName()

const displayedTags = computed<number[]>(() => [
  ...new Set(props.influencer.tags?.identity?.influencer_badge ?? []),
])
</script>

<template>
  <OrangeTitleWithSpacedContent>
    <template #title>{{
      $t('influencer.profile.slug.about.infosAndActivity00')
    }}</template>
    <template #content>
      <InfluencerBadgeIcon
        v-for="tagId in displayedTags"
        :key="tagId"
        :influencer
        :badge-name="getCuratorBadgeName(tagId)"
        class="badge"
      >
        <template #default="{ iconClass, iconText, iconDescription, name }">
          <IconDescriptionElement :icon-class="iconClass.join(' ')">
            <template #title>{{ iconText }}</template>
            <template #subtitle>
              {{ iconDescription }}
              <a
                v-if="name === 'top-media'"
                :href="$t('links.proBadge')"
                target="_blank"
              >
                <VText cfg="sans/14/medium" color="orange-500">{{
                  $t('common.knowmore')
                }}</VText>
              </a>
            </template>
          </IconDescriptionElement>
        </template>
      </InfluencerBadgeIcon>
      <InfluencerGrooverNote :influencer />
    </template>
  </OrangeTitleWithSpacedContent>
</template>
